import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { api } from '../api';

export interface AuthUser {
  id: string;
  email: string;
  role: 'admin' | 'member';
  disabled: boolean;
}

interface AuthState {
  user: AuthUser | null;
  setSession: (user: AuthUser, token: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      setSession: (user, token) => {
        api.setToken(token);
        set({ user });
      },
      logout: () => {
        api.clearToken();
        set({ user: null });
      },
    }),
    { name: 'disit-auth' },
  ),
);
